import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getInvoiceAdditionsListLoading: false,
  getInvoiceAdditionsListFailed: false,
  getInvoiceAdditionsListError: false,
  getInvoiceAdditionsListMessage: null,
  invoiceAdditionsList: [],
  invoiceAdditionsListTotalRecords: 0,

  deletedInvoiceAdditionsLoading: false,
  deletedInvoiceAdditionsFailed: false,
  deletedInvoiceAdditionsError: false,
  deletedInvoiceAdditionsMessage: null,
  deletedInvoiceAdditionsList: [],
  deletedInvoiceAdditionsTotalRecords: 0,

  createInvoiceAdditionLoading: false,
  createInvoiceAdditionFailed: false,
  createInvoiceAdditionError: false,
  createInvoiceAdditionMessage: null,

  toggleInvoiceAdditionStatusLoading: false,
  toggleInvoiceAdditionStatusFailed: false,
  toggleInvoiceAdditionStatusError: false,
  toggleInvoiceAdditionStatusMessage: null,

  deleteInvoiceAdditionLoading: false,
  deleteInvoiceAdditionFailed: false,
  deleteInvoiceAdditionError: false,
  deleteInvoiceAdditionMessage: null
};

function invoiceAdditionsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.GET_INVOICE_ADDITIONS_LIST_LOADING: {
      return {
        ...state,
        getInvoiceAdditionsListLoading: true,
        getInvoiceAdditionsListFailed: false,
        getInvoiceAdditionsListError: false,
        getInvoiceAdditionsListMessage: null,
        invoiceAdditionsList: [],
        invoiceAdditionsListTotalRecords: 0,

        toggleInvoiceAdditionStatusLoading: false,
        toggleInvoiceAdditionStatusFailed: false,
        toggleInvoiceAdditionStatusError: false,
        toggleInvoiceAdditionStatusMessage: null
      };
    }
    case actionTypes.GET_INVOICE_ADDITIONS_LIST_SUCCESS: {
      return {
        ...state,
        getInvoiceAdditionsListLoading: false,
        getInvoiceAdditionsListFailed: false,
        getInvoiceAdditionsListError: false,
        getInvoiceAdditionsListMessage: null,
        invoiceAdditionsList: [...action.payload.cafeFactorAdditions],
        invoiceAdditionsListTotalRecords: action.payload.totalRecords
      };
    }
    case actionTypes.GET_INVOICE_ADDITIONS_LIST_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        getInvoiceAdditionsListLoading: false,
        getInvoiceAdditionsListFailed: true,
        getInvoiceAdditionsListError: false,
        getInvoiceAdditionsListMessage: message,
        invoiceAdditionsList: [],
        invoiceAdditionsListTotalRecords: 0
      };
    }
    case actionTypes.GET_INVOICE_ADDITIONS_LIST_REJECT: {
      return {
        ...state,
        getInvoiceAdditionsListLoading: false,
        getInvoiceAdditionsListFailed: false,
        getInvoiceAdditionsListError: true,
        getInvoiceAdditionsListMessage: null,
        invoiceAdditionsList: [],
        invoiceAdditionsListTotalRecords: 0
      };
    }

    case actionTypes.CREATE_INVOICE_ADDITION_LOADING: {
      return {
        ...state,
        createInvoiceAdditionLoading: true,
        createInvoiceAdditionFailed: false,
        createInvoiceAdditionError: false,
        createInvoiceAdditionMessage: null
      };
    }
    case actionTypes.CREATE_INVOICE_ADDITION_SUCCESS: {
      return {
        ...state,
        createInvoiceAdditionLoading: false,
        createInvoiceAdditionFailed: false,
        createInvoiceAdditionError: false,
        createInvoiceAdditionMessage: null
      };
    }
    case actionTypes.CREATE_INVOICE_ADDITION_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        createInvoiceAdditionLoading: false,
        createInvoiceAdditionFailed: true,
        createInvoiceAdditionError: false,
        createInvoiceAdditionMessage: message
      };
    }
    case actionTypes.CREATE_INVOICE_ADDITION_REJECT: {
      return {
        ...state,
        createInvoiceAdditionLoading: false,
        createInvoiceAdditionFailed: false,
        createInvoiceAdditionError: true,
        createInvoiceAdditionMessage: null
      };
    }

    case actionTypes.DELETE_INVOICE_ADDITION_LOADING: {
      return {
        ...state,
        deleteInvoiceAdditionLoading: true,
        deleteInvoiceAdditionFailed: false,
        deleteInvoiceAdditionError: false,
        deleteInvoiceAdditionMessage: null
      };
    }
    case actionTypes.DELETE_INVOICE_ADDITION_SUCCESS: {
      return {
        ...state,
        deleteInvoiceAdditionLoading: false,
        deleteInvoiceAdditionFailed: false,
        deleteInvoiceAdditionError: false,
        deleteInvoiceAdditionMessage: null
      };
    }
    case actionTypes.DELETE_INVOICE_ADDITION_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        deleteInvoiceAdditionLoading: false,
        deleteInvoiceAdditionFailed: true,
        deleteInvoiceAdditionError: false,
        deleteInvoiceAdditionMessage: message
      };
    }
    case actionTypes.DELETE_INVOICE_ADDITION_REJECT: {
      return {
        ...state,
        deleteInvoiceAdditionLoading: false,
        deleteInvoiceAdditionFailed: false,
        deleteInvoiceAdditionError: true,
        deleteInvoiceAdditionMessage: null
      };
    }

    case actionTypes.TOGGLE_INVOICE_ADDITION_STATUS_LOADING: {
      return {
        ...state,
        toggleInvoiceAdditionStatusLoading: true,
        toggleInvoiceAdditionStatusFailed: false,
        toggleInvoiceAdditionStatusError: false,
        toggleInvoiceAdditionStatusMessage: null
      };
    }
    case actionTypes.TOGGLE_INVOICE_ADDITION_STATUS_SUCCESS: {
      return {
        ...state,
        toggleInvoiceAdditionStatusLoading: false,
        toggleInvoiceAdditionStatusFailed: false,
        toggleInvoiceAdditionStatusError: false,
        toggleInvoiceAdditionStatusMessage: null
      };
    }
    case actionTypes.TOGGLE_INVOICE_ADDITION_STATUS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        toggleInvoiceAdditionStatusLoading: false,
        toggleInvoiceAdditionStatusFailed: true,
        toggleInvoiceAdditionStatusError: false,
        toggleInvoiceAdditionStatusMessage: message
      };
    }
    case actionTypes.TOGGLE_INVOICE_ADDITION_STATUS_REJECT: {
      return {
        ...state,
        toggleInvoiceAdditionStatusLoading: false,
        toggleInvoiceAdditionStatusFailed: false,
        toggleInvoiceAdditionStatusError: true,
        toggleInvoiceAdditionStatusMessage: null
      };
    }

    case actionTypes.GET_DELETED_INVOICE_ADDITIONS_LIST_LOADING: {
      return {
        ...state,
        deletedInvoiceAdditionsLoading: true,
        deletedInvoiceAdditionsFailed: false,
        deletedInvoiceAdditionsError: false,
        deletedInvoiceAdditionsMessage: null,
        deletedInvoiceAdditionsList: [],
        deletedInvoiceAdditionsTotalRecords: 0
      };
    }
    case actionTypes.GET_DELETED_INVOICE_ADDITIONS_LIST_SUCCESS: {
      return {
        ...state,
        deletedInvoiceAdditionsLoading: false,
        deletedInvoiceAdditionsFailed: false,
        deletedInvoiceAdditionsError: false,
        deletedInvoiceAdditionsMessage: null,
        deletedInvoiceAdditionsList: [...action.payload.cafeFactorAdditions],
        deletedInvoiceAdditionsTotalRecords: action.payload.totalRecords
      };
    }
    case actionTypes.GET_DELETED_INVOICE_ADDITIONS_LIST_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        deletedInvoiceAdditionsLoading: false,
        deletedInvoiceAdditionsFailed: true,
        deletedInvoiceAdditionsError: false,
        deletedInvoiceAdditionsMessage: message,
        deletedInvoiceAdditionsList: [],
        deletedInvoiceAdditionsTotalRecords: 0
      };
    }
    case actionTypes.GET_DELETED_INVOICE_ADDITIONS_LIST_REJECT: {
      return {
        ...state,
        deletedInvoiceAdditionsLoading: false,
        deletedInvoiceAdditionsFailed: false,
        deletedInvoiceAdditionsError: true,
        deletedInvoiceAdditionsMessage: null,
        deletedInvoiceAdditionsList: [],
        deletedInvoiceAdditionsTotalRecords: 0
      };
    }
    default:
      return state;
  }
}

export default invoiceAdditionsReducer;
